module.exports = __webpack_public_path__ + "media/images/spinner-778ae9cd.gif";